
































































































































import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Prop } from "vue-property-decorator"

import { Product } from '../Products/types'
import { Report } from "./types"

@Component
export default class ShopProductReports extends Vue {
  @Prop() getReports!: () => Promise<Array<Report>>

  @Prop() getPreview!: (image: string) => string

  productsReport: Array<Report> = []

  isLoading = false

  getDescription(product: Product): string {
    if (isMobile()) {
      return product.description.length > 70 ? product.description.slice(0, 67) + '...' : product.description
    } else {
      return product.description.length > 200 ? product.description.slice(0, 197) + '...' : product.description
    }
  }

  getRedemptionPercentage(sales: number, notSales: number): string {
    const percent = (sales + notSales) / 100

    const redemption = Math.round(sales / percent)
    return `${ redemption }%`
  }

  created(): void {
    this.isLoading = true

    this.getReports()
      .then((reports) => this.productsReport = reports)
      .finally(() => this.isLoading = false)
  }
}
